import { getServiceProvider } from '@takeshape/service-providers';
import { avatars, logos } from '../assets/index.js';
import { createServiceProvider } from '../util/index.js';

export default createServiceProvider({
  ...getServiceProvider('googleVertex'),
  avatarPath: avatars.googleVertex,
  logoPath: logos.googleVertex
});
